export const PROMO_MIN_LENGTH = 4
export const PROMO_MAX_LENGTH = 15

export function normalizePromoInput(value: string): string {
  return value.toUpperCase().replace(/[^A-ZА-ЯЁ0-9 _-]/g, "").slice(0, PROMO_MAX_LENGTH)
}

function bytesToBinary(bytes: Uint8Array): string {
  let binary = ""
  for (const byte of bytes) binary += String.fromCharCode(byte)
  return binary
}

export function encodePromoStartParam(value: string): string {
  const normalized = normalizePromoInput(value)
  const encoded = btoa(bytesToBinary(new TextEncoder().encode(normalized)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "")
  return `promo64_${encoded}`
}

export function decodePromoStartParam(value: string): string {
  if (value.startsWith("promo64_")) {
    const encoded = value.slice(8)
    if (!encoded) return ""
    try {
      const base64 = encoded.replace(/-/g, "+").replace(/_/g, "/")
      const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4)
      const binary = atob(padded)
      const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
      return normalizePromoInput(new TextDecoder().decode(bytes))
    } catch {
      return ""
    }
  }
  if (value.startsWith("promo_")) return normalizePromoInput(value.slice(6))
  return ""
}
